module.exports = __webpack_public_path__ + "img/logo-community-ware.92c04f47.png";